import { render, staticRenderFns } from "./multipleReplyCommentDrawer.vue?vue&type=template&id=539ff4cc&scoped=true"
import script from "./multipleReplyCommentDrawer.vue?vue&type=script&lang=js"
export * from "./multipleReplyCommentDrawer.vue?vue&type=script&lang=js"
import style0 from "./multipleReplyCommentDrawer.vue?vue&type=style&index=0&id=539ff4cc&prod&lang=scss&scoped=true"
import style1 from "./multipleReplyCommentDrawer.vue?vue&type=style&index=1&id=539ff4cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ff4cc",
  null
  
)

export default component.exports